export type ReportsKeyParams = {
  entityId: number;
  includeAccountSummaryReports?: boolean;
  includeMultiDatasetReports?: boolean;
};

export type SavedViewsKeyParams = {
  reportId?: string;
  legacyReportId?: string;
  reportVersion: string;
};

export type SavedViewInfoKeyParams = {
  savedViewId: string;
};

export type EmbedKeyParams = {
  embedId: string;
};

export type ReportInfoKeyParams = {
  reportId: string;
};

// Params embedded as objects so invalidateQueries can target exact matches,
// and broad prefix matches (e.g. [...all, 'reports']) sweep every param variant.
export const embedPickerQueryKeys = {
  all: ['embedPicker'] as const,
  reports: (params: ReportsKeyParams) => [...embedPickerQueryKeys.all, 'reports', params] as const,
  savedViews: (params: SavedViewsKeyParams) =>
    [...embedPickerQueryKeys.all, 'savedViews', params] as const,
  savedViewInfo: (params: SavedViewInfoKeyParams) =>
    [...embedPickerQueryKeys.all, 'savedViewInfo', params] as const,
  embed: (params: EmbedKeyParams) => [...embedPickerQueryKeys.all, 'embed', params] as const,
  reportInfo: (params: ReportInfoKeyParams) =>
    [...embedPickerQueryKeys.all, 'reportInfo', params] as const
} as const;
